import { Maximize, Minimize } from 'lucide-react';

import { usePantallaCompleta } from '@/hooks/use-pantalla-completa';
import { cn } from '@/lib/utils';

interface BotonPantallaCompletaProps {
  /** Ajustes de posición/visibilidad según dónde se coloque. */
  className?: string;
  /** `oscuro` para usarlo sobre el panel turquesa del login. */
  tono?: 'claro' | 'oscuro';
}

/**
 * Botón de pantalla completa del navegador.
 *
 * Se usa en el armazón del panel (barra superior) y en el login, para que la
 * aplicación pueda ocupar toda la pantalla sin depender de `F11`. Si el navegador
 * no soporta la API, no se dibuja nada.
 */
export function BotonPantallaCompleta({ className, tono = 'claro' }: BotonPantallaCompletaProps) {
  const { disponible, esCompleto, alternar } = usePantallaCompleta();

  if (!disponible) return null;

  const etiqueta = esCompleto ? 'Salir de pantalla completa' : 'Pantalla completa';

  return (
    <button
      type="button"
      onClick={() => void alternar()}
      aria-label={etiqueta}
      aria-pressed={esCompleto}
      title={etiqueta}
      className={cn(
        'flex size-10 cursor-pointer items-center justify-center rounded-lg transition-colors',
        tono === 'oscuro'
          ? 'text-white/70 hover:bg-white/10 hover:text-white'
          : 'text-ink-600 hover:bg-ink-100 hover:text-ink-900',
        className,
      )}
    >
      {esCompleto ? (
        <Minimize className="size-5" aria-hidden="true" />
      ) : (
        <Maximize className="size-5" aria-hidden="true" />
      )}
    </button>
  );
}
